import React from 'react';

const NavSpacer = () => <li className="nav-item nav-item-spacer" />;
export default NavSpacer;
